const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://kcnninhxuan-api.cgis.asia/",
    media_url: "https://kcnninhxuan-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "kcnninhxuan",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/kcnninhxuan/wms/",
    datastore: 'kcnninhxuan',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
  },
    production: {
      api: "https://kcnninhxuan-api.cgis.asia/",
      media_url: "https://kcnninhxuan-api.cgis.asia/",
      domainAdminSide: "https://kcnninhxuan-admin.cgis.asia",
      domainUserSide: "https://kcnninhxuan.cgis.asia",
      domainName: "cgis.asia",
      workSpace: "kcnninhxuan",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
      datastore: 'kcnninhxuan',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
      // wmsBaseLink: "https://geo.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];